export const LIST_SECTION_REQUEST = 'LIST_SECTION_REQUEST';
export const LIST_SECTION_REQUEST_SUCCESS = 'LIST_SECTION_REQUEST_SUCCESS';
export const LIST_SECTION_REQUEST_FAILURE = 'LIST_SECTION_REQUEST_FAILURE';

export const CLEAR_SECTION_LIST = 'CLEAR_SECTION_LIST';